
import { mixins } from "vue-class-component";
import { Component, Vue } from "vue-property-decorator";

import VignetteLogo from "@/components/VignetteLogo.vue";
import { ViewAnalytics } from "@/mixins";
import { ApiService, LogService, RouterService, SnackbarService } from "@/services";
import { ApplicationModule, getStoreModule, SessionModule } from "@/store";
import { MetadataKeys, VignetteRoutes } from "@/types";

@Component({
  components: {
    VignetteLogo,
  },
})
export default class Contact extends mixins(ViewAnalytics) {
  private applicationStore!: ApplicationModule;
  private sessionStore!: SessionModule;

  private message = "";
  private isFormValid = false;
  private isFormLoading = false;

  // Override for PageTitle mixin
  pageName = "Contact";

  private messageRules = [
    // @ts-expect-error use validation without type for now
    (v) => !!v.trim() || "Message is required",
    // @ts-expect-error use validation without type for now
    (v) => (v && v.trim().length <= 10000) || "Message must be less than 10,000 characters",
  ];

  created(): void {
    this.applicationStore = getStoreModule(ApplicationModule, this.$store);
    this.sessionStore = getStoreModule(SessionModule, this.$store);
  }

  mounted(): void {
    this.setAnalyticsMetadata(MetadataKeys.PAYWALLED_CONTENT_STATUS, "Public");
    this.setAnalyticsMetadata(MetadataKeys.PAGE_TYPE, "Public Page");
    this.setAnalyticsMetadata(MetadataKeys.SITESECTION, "Public Pages");
    this.pushPageViewEvent();
  }

  get isUserLoggedIn(): boolean {
    return this.sessionStore.isLoggedIn;
  }

  get emailAddress(): string {
    return this.applicationStore.getVignetteEmailAddress;
  }

  get emailLink(): string {
    return this.applicationStore.getVignetteEmailLink;
  }

  get signUpPath(): string {
    return this.$router.resolve({ name: VignetteRoutes.SignUp }).href;
  }

  navigateToSignUpPage(): void {
    RouterService.navigateByName(this.$router, VignetteRoutes.SignUp);
  }

  submitForm(): void {
    // We shouldn't need to check this as button is disabled if form isn't valid, but just in case;
    const form: Element | Vue | (Vue | Element)[] | undefined = this.$refs.contactForm;
    // @ts-expect-error Vuetify validation doesn't have TS type definition
    if (!form.validate()) {
      LogService.error(`Contact.submitForm: contact form submitted with validation errors.`);
      return;
    }

    this.isFormLoading = true;

    ApiService.postUserContact(this.message.trim(), false).then((response) => {
      this.isFormLoading = false;

      if (response.statusCode === 200) {
        LogService.info(`Contact.submitForm is successful.`);
        SnackbarService.displaySnackbar("Form successfully submitted.", "secondary");
        this.message = "";
        // @ts-expect-error Vuetify validation doesn't have TS type definition
        form.resetValidation();
      } else {
        LogService.error(`SignUp.submitForm failed: '${response.error_message}'`);
        SnackbarService.displaySnackbar("An error occurred, please try again.");
      }
    });
  }
}
